import MockAdapter from 'axios-mock-adapter';

import { responses } from './responses';

import type { Response } from './types';
import type { Context } from '@nuxt/types';

export default ({ $axios, isDev }: Context): void => {
  if (!isDev) {
    return;
  }

  const mock: MockAdapter = new MockAdapter($axios);

  responses.forEach(([method, url, statusCode, data]: Response): void => {
    mock[method](url).reply(statusCode, data ?? null);
  });

  mock.onAny()
    .passThrough();
};
